const getters = {
    module: (state) => state.module,
    loading: state => state.loading
};

export default getters;